<template>
	<!-- 我的足迹 弹窗开始 -->
	<div class="explain" id="mytracks">
	  <div class="rightWap">
	    <div class="myTracks" v-loading="loadingMask">
	      <h1>我的足迹<img src="/images/rightClose.png" class="closePop" @click="closeFloat"/></h1>
	      <div class="total">          
	        <p style="float: right">全部 <span>{{totalResultCount}}</span> 条浏览记录</p>
	        <div class="sort">
	          <span @click="seltimeVisible=!seltimeVisible" @blur="seltimeVisible=false">
							<i>{{timetypetxt}}</i>
							<img v-if="seltimeVisible" src="/images/dIcon.png"/>
							<img v-else src="/images/down.png"/>
						</span>
	          <ul v-show="seltimeVisible">
	            <li @click="selTimeType('')">一个月内</li>
	            <li @click="selTimeType('2')">三个月内</li>
	            <li @click="selTimeType('3')">半年内</li>
	            <li @click="selTimeType('4')">一年内</li>
	          </ul>
	        </div>
	      </div>
				<div class="tracksdiv">
					<div class="tracks" v-for="(item,index) in resultDataList">
					  <div class="date">
					    <span>{{item.time.substring(8,10)}}</span>
					    <em>{{item.time.substring(0,7)}}</em>
					  </div>
					  <ul>
					    <li v-for="(aitem,aindex) in item.data">
								<router-link :to="{ name: 'detail', params: { id: aitem.id }}" target="_blank">{{aitem.title}}<img src="images/arw_bule.png"/></router-link>
							</li>
					    <!-- <li><a href="##">新版国家职业分类大典新增职业聚焦数字与绿色<img src="images/arw_bule.png"/></a></li>
					    <li><a href="##">用知识产权为数字经济插上“翅膀”<img src="images/arw_bule.png"/></a></li>
					    <li><a href="##">未来我国如何深耕新基建<img src="images/arw_bule.png"/></a></li> -->
					  </ul>
					</div>
				</div>
	      <!-- <div class="tracks">
	        <div class="date">
	          <span>15</span>
	          <em>2022/03</em>
	        </div>
	        <ul>
	          <li><a href="##">阿联酋“雪中送炭”，德国能源危机稍缓<img src="images/arw_bule.png"/></a></li>
	          <li><a href="##">金壮龙：人工智能是数字经济发展的重点领域<img src="images/arw_bule.png"/></a></li>
	          <li><a href="##">我国牵头自动驾驶测试场景评价国际标准立项<img src="images/arw_bule.png"/></a></li>
	          <li><a href="##">网安园加速扩容，引入27家高精尖企业<img src="images/arw_bule.png"/></a></li>
	        </ul>
	      </div>
	      <div class="tracks">
	        <div class="date">
	          <span>10</span>
	          <em>2022/03</em>
	        </div>
	        <ul>
	          <li><a href="##">挖数字经济潜能，为城市发展赋能<img src="images/arw_bule.png"/></a></li>
	          <li><a href="##">“卡位”数字经济转型ATM机何去何从<img src="images/arw_bule.png"/></a></li>
	          <li><a href="##">亚特兰大联储主席：美联储通胀目标且避免严重损害经济<img src="images/arw_bule.png"/></a></li>
	        </ul>
	      </div> -->
	      <div class="pagediv">
	      	<el-pagination
	      				@size-change="changePageSize"
	      				@current-change="changeSearchPage"
	      				:current-page="pageNum"
	      				:page-sizes="[10, 15, 20]"
	      				:page-size="pageSize"
	      				layout="prev, pager, next"
	      				:total="totalResultCount">
	      			</el-pagination>
	      </div>
	    </div>
	  </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				seltimeVisible:false,
				timetype:'',
				timetypetxt:'一个月内',
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
			}
		},
		props: [
			'userinfo'
		],
		mounted: function() {
			this.getHistoryfnc();
		},
		methods: {
			getHistoryfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/GetUserRecord',
						responseType: 'json',
						params: {
							userid: this.userinfo.userAccountID,
							iPageNum: this.pageNum,
							iPageSize: this.pageSize,
							type:this.timetype,
						},
					})
					.then(function(response) {
						var responsedata = response.data.data.data.data;
						var tempdata=[];
						if(responsedata){
							for(var i=0;i<responsedata.length;i++){
								if(tempdata.length>0&&responsedata[i].browsetime.substring(0,10)==tempdata[tempdata.length-1].time){
									tempdata[tempdata.length-1].data.push(responsedata[i]);
								}
								else {
									tempdata.push({
										time:responsedata[i].browsetime.substring(0,10),
										data:[responsedata[i]]
									})
								}
							}
						}
						_this.resultDataList = tempdata;
						_this.totalResultCount = parseInt(response.data.data.data.totalcount?response.data.data.data.totalcount:'0');
						_this.loadingMask = false;
						_this.$emit('senddata',_this.totalResultCount);
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.getHistoryfnc();
			},
			changeSearchPage: function(page) {
				// console.log(page);
				this.pageNum = page;
				this.getHistoryfnc();
			},
			selTimeType:function(type){
				if(type=='2'){
					this.timetype='2';
					this.timetypetxt='三个月内';
					this.seltimeVisible=false;
				}
				else if (type=='3'){
					this.timetype='3';
					this.timetypetxt='半年内';
					this.seltimeVisible=false;
				}
				else if (type=='4'){
					this.timetype='4';
					this.timetypetxt='半年内';
					this.seltimeVisible=false;
				}
				else{
					this.timetype='';
					this.timetypetxt='一个月内';
					this.seltimeVisible=false;
				}
				this.pageNum=1;
				this.pageSize=15
				this.getHistoryfnc();
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
		},
	}
</script>

<style>
</style>
